import Link from '@sats-group/ui-lib/react/link';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ArticleLinkCard from '~/client/components/article-link-card/article-link-card';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import type { ArticlesCategoryPage as Props } from './articles-category-page.types';

const ArticlesCategoryPage: React.FunctionComponent<Props> = ({
  description,
  layout,
  subcategories,
  title,
}) => (
  <Layout {...layout}>
    <div className="articles-category-page">
      <ContentContainer>
        <Text
          className="articles-category-page__title"
          elementName="h1"
          size={Text.sizes.headline2}
          theme={Text.themes.headline}
          italic
        >
          {title}
        </Text>
        {description ? (
          <Text
            className="articles-category-page__description"
            elementName="p"
            size={Text.sizes.basic}
            theme={Text.themes.normal}
          >
            {description}
          </Text>
        ) : null}
        {subcategories.length ? (
          <ul className="articles-category-page__categories">
            {subcategories.map(cat => (
              <li className="articles-category-page__category" key={cat.title}>
                <Text
                  className="articles-category-page__category-title"
                  elementName="h2"
                  size={Text.sizes.headline3}
                  theme={Text.themes.normal}
                >
                  {cat.title}
                </Text>
                {cat.description ? (
                  <Text
                    elementName="p"
                    size={Text.sizes.basic}
                    theme={Text.themes.normal}
                  >
                    {cat.description}
                  </Text>
                ) : null}
                <ul className="articles-category-page__category-cards">
                  {cat.cards.map(card => (
                    <li key={card.href}>
                      <ArticleLinkCard {...card} />
                    </li>
                  ))}
                </ul>
                <Link {...cat.link} />
              </li>
            ))}
          </ul>
        ) : null}
      </ContentContainer>
    </div>
  </Layout>
);

export default ArticlesCategoryPage;
